import {Publication} from "../../utils/types";
import React, {ReactElement} from "react";
import {Link} from "react-router-dom";
import {Divider, Typography} from "antd";
import { toSafeInnerHTML } from '../../utils/utils';

interface Props {
    publication: Publication
}

const PublicationDescription = ({publication}: Props) => {
    let allAuthors = '';
    if (publication.all_authors) {
        const allAuthorsArray = publication.all_authors.split(',').map((author: string) => author.trim());
        if (allAuthorsArray.length > 3) {
            if (publication.authorsCnt !== null) {
                allAuthors = `${allAuthorsArray[0]}, ${allAuthorsArray[1]}, and ${publication.authorsCnt - 2} others`;
            } else {
                allAuthors = `${allAuthorsArray[0]}, ${allAuthorsArray[1]}, and ${allAuthorsArray.length - 2} others`;
            }
        } else {
            allAuthors = publication.all_authors;
        }
    }

    const description = publication && (
        <React.Fragment>
            {publication.pubSrcName &&
            <span
                  dangerouslySetInnerHTML={{ __html: `<strong><em>${toSafeInnerHTML(publication.pubSrcName)}</em></strong> <br />` }}>
            </span>}

            {publication.date && <>
            <span>
                <strong>Date</strong>: {publication.date}
            </span><br/></>}

            {allAuthors &&
            <span>
                <strong>Authors</strong>: <span style={{ color: '#737CA1' }}>{allAuthors}</span> <br/>
            </span>}

            {publication.sfu_authors &&
            <span>
                <strong>SFU faculty authors</strong>: {publication.sfu_authors.map(
                (author, index) => (
                    <React.Fragment key={index}>
                        <Link to={`/profile/${author.random_id}`}>
                            <span className='gray-link-button'>{author.preferred_last_name}, {author.preferred_first_name && `${author.preferred_first_name[0]}.`}</span>
                        </Link>
                        {index !== publication.sfu_authors.length - 1 &&
                        <Divider type='vertical' style={{margin: '0 0.3em'}}/>}
                    </React.Fragment>
                )
            )}<br/>
            </span>}

            {publication.abstract &&
            <Typography.Paragraph ellipsis={{rows: 2, expandable: true, symbol: 'more'}}
                                  style={{color: 'rgba(0,0,0, 0.45)'}}>
                <strong>Abstract</strong>: {'... '.concat(publication.abstract.slice(publication.abstract.indexOf('. ') + 2))}
            </Typography.Paragraph>}
        </React.Fragment>
    )

    return description as ReactElement;
};

export default PublicationDescription;